export default __webpack_public_path__ + "static/media/superhost_user_key.f98c5d6e.png";